import React from "react";
import Header from "./header";
import Footer from "./footer";

export default function Layout(props: any) {
  return (
    <>
      <Header />
      {props.children}
      <Footer />
    </>
  );
}
